import React from 'react'

export const ActiveKpaContext = React.createContext({
  activeKpa: {},
  setActiveKpa: () => {},
})
